import React from 'react';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';

const Pa02GraphUI = (props: UIProperties<Pa02GraphUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			right: '20px',
			top: '25px',
			width: '185px',
			height: '118px'
		}}>
			
		</div>
	);

};

export interface Pa02GraphUIConfig extends BaseConfig{
}

export default Pa02GraphUI;